import { render, staticRenderFns } from "./kyc-notice.vue?vue&type=template&id=02f9506f&"
import script from "./kyc-notice.vue?vue&type=script&lang=js&"
export * from "./kyc-notice.vue?vue&type=script&lang=js&"
import style0 from "./kyc-notice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports